import type { ValidationError } from '../../models/ValidationError';
import type { SchemaType } from '../../store/forms/Asset-Editor/SchemaTypeOptions';
import clientUtils from '../../utils/clientUtils';

export function validateFileExtension(schemaType: SchemaType, fileName: string): ValidationError | null {
  // console.log('validateFileExtension', { schemaType, fileName });

  const validationMessage = clientUtils.validateFileExtension(schemaType, fileName);

  if (validationMessage != null) {
    return { fieldId: 'ingestFile', message: validationMessage };
  }
  return null;
}
